import { z } from 'zod';
import { YEAR_END_ADJUSTMENT_DOCUMENT_SECTION_KEYS } from '@/features/labor-core/-components/year-end-adjustment-confirmation/lib/documentSections';

/** oRPC `listYearEndAdjustmentInstancesByTagContract` の orderBy / status と同期 */
export const YEAR_END_ADJUSTMENT_OVERALL_STATUSES = ['completed', 'returned', 'awaitingReview', 'pendingAction'] as const;

/** 書類タブ（'all' + カタログ順の6書類キー。書類リストは SECTION_KEYS から導出） */
export const YEAR_END_ADJUSTMENT_DOCUMENT_TABS = ['all', ...YEAR_END_ADJUSTMENT_DOCUMENT_SECTION_KEYS] as const;
export const YEAR_END_ADJUSTMENT_CONFIRMATION_ORDER_BY = ['target', 'overallStatus', 'dueDate', 'lastUpdatedAt'] as const;
export const YearEndAdjustmentConfirmationSearchSchema = z.object({
  operationPackageId: z.string().min(1),
  operationPackagePatternId: z.string().min(1),
  tagId: z.string().min(1),
  pageIndex: z.number().int().nonnegative().catch(0),
  pageSize: z.number().int().positive().max(2000).catch(50),
  orderBy: z.enum(YEAR_END_ADJUSTMENT_CONFIRMATION_ORDER_BY).optional().catch(undefined),
  orderDirection: z.enum(['asc', 'desc']).optional().catch(undefined),
  searchText: z.string().max(500).optional().catch(undefined),
  status: z.array(z.enum(YEAR_END_ADJUSTMENT_OVERALL_STATUSES)).optional().catch(undefined),
  documentTab: z.enum(YEAR_END_ADJUSTMENT_DOCUMENT_TABS).optional().catch(undefined)
});
export type YearEndAdjustmentConfirmationSearch = z.infer<typeof YearEndAdjustmentConfirmationSearchSchema>;